import { render } from "./SubMenu.vue?vue&type=template&id=0e481116&scoped=true&bindings={\"content\":\"props\",\"showExpand\":\"props\",\"ismobile\":\"props\",\"ismobileexpanded\":\"props\",\"sidebarCss\":\"options\",\"handleClick\":\"options\"}"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"

import "./SubMenu.vue?vue&type=style&index=0&lang=css"
import "./SubMenu.vue?vue&type=style&index=1&id=0e481116&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e481116"

export default script